import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.match";

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useImportsForExample, useScope } from '@docpocalypse/gatsby-theme-core';
import { canParse } from '@docpocalypse/gatsby-theme-core/can-parse';
import React from 'react';
import CodeBlock from './CodeBlock';
import LiveCode from './LiveCode';
export var getLanguage = function getLanguage(className) {
  if (className === void 0) {
    className = '';
  }

  var _ref = className.match(/language-(\w+)/) || [],
      mode = _ref[1];

  return mode;
};
export var toText = function toText(node) {
  var nodes = React.Children.toArray(node);
  return nodes.filter(function (c) {
    return c !== true && c !== false && c !== null;
  }).reduce(function (str, next) {
    if (!React.isValidElement(next)) return str + String(next);
    return str + toText(next.props.children);
  }, '');
};
/** @public */

var Pre = function Pre(props) {
  var _props$children$props, _props$children;

  var imports = useImportsForExample(props.name);
  var scope = useScope();

  var _ref2 = (_props$children$props = (_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.props) !== null && _props$children$props !== void 0 ? _props$children$props : {},
      children = _ref2.children,
      _1 = _ref2.originalType,
      _2 = _ref2.metastring,
      _3 = _ref2.mdxType,
      _4 = _ref2.parentName,
      codeProps = _objectWithoutPropertiesLoose(_ref2, ["children", "originalType", "metastring", "mdxType", "parentName"]);

  var flatCode = toText(children);
  var language = codeProps.language || getLanguage(codeProps.className);
  var isStatic = props.static;
  if (isStatic == null) isStatic = codeProps.static === true || !canParse(language) && codeProps.live !== true;
  return !isStatic ? /*#__PURE__*/React.createElement(LiveCode, Object.assign({
    code: flatCode
  }, codeProps, {
    scope: scope,
    language: language,
    resolveImports: imports
  })) : /*#__PURE__*/React.createElement(CodeBlock, Object.assign({}, codeProps, {
    language: language,
    code: flatCode
  }));
};

export default Pre;